// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AccountAppsUpdateSchema } from './v1/accountApps/updateSchema';
import { v1JobSchema } from './v1/jobSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const updatesAppUserImportOptionsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("App id"),
  app_user_id: z.number().int().describe("AppUser id"),
});

export const updatesAppUserImportOptionsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Integration options updated.
 */
export const updatesAppUserImportOptions200Schema = z.lazy(() => v1JobSchema);

/**
 * @description AppUser not found
 */
export const updatesAppUserImportOptions404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const updatesAppUserImportOptionsMutationRequestSchema = z.lazy(() => v1AccountAppsUpdateSchema);

export const updatesAppUserImportOptionsMutationResponseSchema = z.lazy(() => updatesAppUserImportOptions200Schema);
